import React from 'react';

import styled from 'styled-components';

import ShopperEmailsControls from './ShopperEmailsControls';
import ShopperEmailsTable from './ShopperEmailsTable';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 10px 30px;
`;

const ShopperEmailsData = () => {
  return (
    <Container>
      <ShopperEmailsControls />
      <ShopperEmailsTable />
    </Container>
  );
};

export default ShopperEmailsData;
